import { bytes_to_format } from "@/components/shared/utils";
import { fetchStorageTypeV2 } from "@/components/vps/qemu/configurator/configurator_utils";
import * as types from "./qemu.types";

// HELPERS
export const get_percentage_color_indicator = (v) => {
	switch (true) {
		case v < 70:
			return "success.main";
		case v < 90:
			return "warning.main";
		default:
			return "error.main";
	}
};

// HELPERS
export const get_progressbar_color = (v) => {
	switch (true) {
		case v < 70:
			return "success";
		case v < 90:
			return "warning";
		default:
			return "error";
	}
};

export const format_bytes = (bytes, decimals = 2) => {
	if (bytes === 0) {
		return "0 Bytes";
	}

	const k = 1024;
	const decimalCount = decimals < 0 ? 0 : decimals;
	const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

	const i = Math.floor(Math.log(bytes) / Math.log(k));

	return `${Number.parseFloat((bytes / k ** i).toFixed(decimalCount))} ${sizes[i]}`;
};

export const get_timestamp_duration = (t, timestamp) => {
	const timestampNumber = Number(timestamp);

	const d = Math.floor(timestampNumber / (3600 * 24));
	const h = Math.floor((timestampNumber % (3600 * 24)) / 3600);
	const m = Math.floor((timestampNumber % 3600) / 60);
	const s = Math.floor(timestampNumber % 60);

	const dDisplay = `${d} ${
		d === 1 ? t("vps.management.general.day") : t("vps.management.general.days")
	}`;

	const addZero = (v) => {
		if (v <= 9) {
			return `0${v}`;
		}
		return v;
	};

	return `${dDisplay}, ${addZero(h)}:${addZero(m)}:${addZero(s)}`;
};

export const map_qemu_to_config_form_values = (body, form) => {
	const {
		id,
		qemu_status,
		qemu_config,
		portal_config,
		public_network,
		private_network,
		sla,
		template_id,
	} = body;

	const diskBulk = fetchStorageTypeV2({
		storage_list: qemu_config.disks,
		storage_type_key: "bulk",
	});

	const data = {
		...form,
		id: id,
		portal_config: {
			...form.portal_config,
			description: portal_config.description,
			extra_backup: portal_config.extra_backup ? 1 : 0,
			snapshots: portal_config.snapshots,
		},
		private_network: private_network
			? {
					...form.private_network,
					...private_network,
					network_id: private_network.id,
				}
			: {
					...form.private_network,
				},
		public_network: {
			...form.public_network,
			ipv4: public_network?.ipv4.length > 0 ? 1 : 0,
			ipv6: public_network?.ipv6.length > 0 ? 1 : 0,
		},
		qemu_config: {
			...form.qemu_config,
			cpu: qemu_status.maxcpu,
			cpu_min: 1,
			disk: bytes_to_format(qemu_status.maxdisk, "GB"),
			disk_min: bytes_to_format(qemu_status.maxdisk, "GB"),
			disks: qemu_config?.disks ? qemu_config?.disks : [],
			extra_storage: {
				bulk: diskBulk?.size || 0,
			},
			mem: bytes_to_format(qemu_status.maxmem, "MB"),
			mem_min: 512,
			name: qemu_status.name,
			node: qemu_status.node,
			vmid: qemu_status.vmid,
		},
		sla: sla,
		template_id: template_id,
	};
	return data;
};

export const qemu_save_config = (payload) => ({
	payload: payload,
	type: types.QEMU_SAVE_CONFIG,
});

export const form_values = {
	id: null,

	/* ------------------------------ PORTAL CONFIG ----------------------------- */
	portal_config: {
		bulk_storage: 0,
		description: "",
		extra_backup: 0,
		snapshots: 0,
	},

	/* ----------------------------- PRIVATE NETWORK ---------------------------- */
	private_network: {
		description: null,
		name: null,
		network_id: null,
		type: "none",
	},

	/* ----------------------------- PUBLIC NETWORK ----------------------------- */
	public_network: {
		ipv4: 0,
		ipv6: 1,
	},

	/* ------------------------------- QEMU CONFIG ------------------------------ */
	qemu_config: {
		cpu: 0,
		cpu_min: 0,
		disk: 0,
		disk_min: 0,
		extra_storage: {
			bulk: 0,
			bulk_min: 0,
			bulk_unit: "TB",
			performance: 0,
			performance_min: 0,
		},
		mem: 0,
		mem_min: 0,
		name: "",
		node: "",
		vmid: "",
	},

	/* ----------------------------------- SLA ---------------------------------- */
	sla: 0,

	/* ------------------------------- SSH CONFIG ------------------------------- */
	ssh_config: {
		allow_own_keys: "0",
		allow_support_engineers: "1",
		external_keys: [],
		internal_keys: [],
	},

	/* --------------------- SELECTED USERNAMES FOR SSH KEYS -------------------- */
	ssh_selected_usernames: [],

	/* ------------------------------- TEMPLATE ID ------------------------------ */
	template_id: 0,
};
